// HomeScreenAdmin.jsx - Versión mejorada con submenús y comportamiento del sidebar arreglado
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { 
  LayoutDashboard, Calculator, MessageSquare, 
  Settings, LogOut, Menu as MenuIcon, X,
   CalendarDays, Grid3X3, BarChart3, ChevronRight, ChevronDown,
  Users, Receipt, 
   Landmark
} from 'lucide-react';
import { useAuth } from '../../metodos/AuthContext';
import logo from '../../assets/logo.png';
import { useUsers } from '../../metodos/userContext';
import PermisoInsuficiente from '../Logins/noPermisos';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import CompletarConfiguracion from './Configuracion/CompletarConfiguracion';

// Rutas con submenús

const routes = [ 
  { 
    name: "Cotizar", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
    permission: 'permiso_solicitudes',
    hasSubmenu: true,
    submenu: [
      { name: "Cotizaciones", icon: <Grid3X3 size={16} />, path: "/dashboard",permission: 'permiso_solicitudes'},
      { name: "proPlataforma", icon: <BarChart3 size={16} />, path: "/dashboard/plataforma",permission: 'permisoTesis'},
      { name: "Tesis Manager", icon: <BarChart3 size={16} />, path: "/dashboard/tesis_manager",permission: 'permisoProPlataforma'},
    ]
  },
  { 
    name: "Dashboard", 
    icon: <LayoutDashboard size={20} />,
    path: "/dashdashv2",
    permission: 'permiso_tutores',
  },
  { 
    name: "Recursos Humanos", 
    icon: <Users size={20} />,
    path: "/tutores",
    permission: 'permiso_tutores',
  },
  { 
    name: "Estadisticas", 
    icon: <BarChart3 size={20} />, 
    path: "/estadisticas",
    permission: 'permiso_estadisticasPlataforma',
    hasSubmenu: true,
    submenu: [
      { name: "Estadisticas", icon: <Grid3X3 size={16} />, path: "/estadisticas",permission: 'permiso_estadisticasPlataforma'},
      { name: "Marketing", icon: <BarChart3 size={16} />, path: "/estadisticas/marketing",permission: 'permiso_estadisticasPlataforma'},
    ]
  },
  { 
    name: "Calendario", 
    icon: <CalendarDays size={20} />, 
    path: "/calendario",
    hasSubmenu: false,
    permission: 'permisoCalendario',
  },
  { 
    name: "Clientes", 
    icon: <Users size={20} />, 
    path: "/clientes",
    permission: 'permisoClientes',
  },
  { 
    name: "Contabilidad ", 
    icon: <Landmark size={20} />, 
    path: "/contabilidad/registrar_pagos",
    permission: 'permiso_contabilidad_central',
    hasSubmenu : true,
    submenu: [
      { name: "Pagos", icon: <Grid3X3 size={16} />, path: "/contabilidad/registrar_pagos",permission: 'permiso_contabilidad_central'},
      //{ name: "Servicios", icon: <Grid3X3 size={16} />, path: "/contabilidad",permission: 'permiso_contabilidad_central'},
      { name: "Costos", icon: <Grid3X3 size={16} />, path: "/contabilidad/costos",permission: 'permiso_contabilidad_central'},
    ],
  },
  { 
    name: "Cuentas de cobro", 
    icon: <Receipt size={20} />,  
    path: "/cuentasDeCobro",
    permission: 'permisoCuentaCobro',
  },
  { 
    name: "Configuracion", 
    icon: <Settings size={20} />, 
    path: "/configuracion",
    hasSubmenu: true,
    submenu: [
      { name: "Configuracion", icon: <Grid3X3 size={16} />, path: "/configuracion",permission: 'permiso_configuracionGeneral'},
      { name: "Agregar Variables", icon: <Grid3X3 size={16} />, path: "/configuracion/agregar",permission: 'permiso_configuracionGeneral'},
    ],
    permission: 'permiso_configuracionGeneral',
  },
  { 
    name: "Whatsapp", 
    icon: <MessageSquare size={20} />, 
    path: "/whatsapp/embudo",
    hasSubmenu: true,
    submenu: [
      { name: "Chat", icon: <Grid3X3 size={16} />, path: "/whatsapp"},
      { name: "Embudo", icon: <Grid3X3 size={16} />, path: "/whatsapp/embudo"},
    ],
  }
];

// Componente para el Sidebar mejorado
const Sidebar = ({routes, activeRoute, collapsed, setCollapsed, onNavigate, onLogout }) => {
  const [expandedMenus, setExpandedMenus] = useState(new Set());
  const isMobile = window.innerWidth < 768;

  const toggleSubmenu = (routeName) => {
    const newExpanded = new Set(expandedMenus);
    if (newExpanded.has(routeName)) {
      newExpanded.delete(routeName);
    } else {
      newExpanded.add(routeName);
    }
    setExpandedMenus(newExpanded);
  };

  const handleMainRouteClick = (route) => {
    if (route.hasSubmenu && !collapsed) {
      toggleSubmenu(route.name);
      // Si tiene submenú y está expandido, navegar a la ruta principal
      if (!expandedMenus.has(route.name)) {
        onNavigate(route.path);
      }
    } else {
      onNavigate(route.path);
      // Auto-colapsar después de seleccionar (especialmente útil en mobile)
      if (isMobile) {
        setCollapsed(true);
      }
    }
  };

  const handleSubmenuClick = (submenuPath) => {
    onNavigate(submenuPath);
    // Auto-colapsar después de seleccionar una opción del submenú
    if (isMobile) {
      setCollapsed(true);
    }
  };

  return (
    <div className={`bg-gradient-to-b from-blue-800 to-blue-900 text-white h-screen fixed transition-all duration-300 shadow-xl z-10
        ${collapsed ? 'w-16' : 'w-64'} 
        ${isMobile && collapsed ? '-translate-x-full' : 'translate-x-0'}`}>
      
      <div className="flex justify-between items-center p-4 border-b border-blue-700/50">
        {!collapsed && (
          <div className="flex justify-center items-center w-full py-4">
            <div className="login-logo">
              <img 
                src={logo} 
                alt="Logo de la aplicación" 
                className="max-w-[100%] mx-auto h-auto" 
                style={{ maxHeight: "60px" }}
              />
            </div>
          </div>
        )}

        <button
          className="p-2 rounded-lg hover:bg-blue-700/50 focus:outline-none transition-colors"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expandir menú" : "Colapsar menú"}
        >
          {collapsed ? <MenuIcon size={20} /> : <X size={20} />}
        </button>
      </div>

      <div className="overflow-y-auto h-[calc(100vh-120px)]">
        <nav className="mt-6 px-3">
          <ul className="space-y-2">
            {routes.map((route) => (
              <li key={route.path}>
                {/* Elemento principal del menú */}
                <button
                  className={`flex items-center w-full p-3 rounded-lg transition-all duration-200 group relative
                    ${activeRoute.startsWith(route.path.split('?')[0])
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'text-blue-100 hover:bg-blue-700/50 hover:text-white'
                    } 
                    ${collapsed ? 'justify-center' : 'justify-between'}`}
                  onClick={() => handleMainRouteClick(route)}
                >
                  <div className="flex items-center">
                    <span className="flex-shrink-0 relative">
                      {route.icon}
                    </span>
                    {!collapsed && (
                      <span className="ml-3 whitespace-nowrap font-medium">{route.name}</span>
                    )}
                  </div>
                  
                  {/* Flecha para submenús */}
                  {!collapsed && route.hasSubmenu && (
                    <span className="transition-transform duration-200">
                      {expandedMenus.has(route.name) ? 
                        <ChevronDown size={16} /> : 
                        <ChevronRight size={16} />
                      }
                    </span>
                  )}
                </button>

                {/* Submenú */}
                {route.hasSubmenu && !collapsed && (
                  <div className={`overflow-hidden transition-all duration-300 ${
                    expandedMenus.has(route.name) ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'
                  }`}>
                    <ul className="mt-2 ml-6 space-y-1 border-l-2 border-blue-600/30 pl-4">
                      {route.submenu?.map((submenuItem) => (
                        <li key={submenuItem.path}>
                          <button
                            className={`flex items-center w-full p-2 rounded-md transition-all duration-200 group
                              ${activeRoute === submenuItem.path
                                ? 'bg-blue-500 text-white'
                                : 'text-blue-200 hover:bg-blue-600/30 hover:text-white'
                              }`}
                            onClick={() => handleSubmenuClick(submenuItem.path)}
                          >
                            <span className="flex-shrink-0">{submenuItem.icon}</span>
                            <span className="ml-2 text-sm font-medium">{submenuItem.name}</span>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Botón de cerrar sesión */}
        <div className="absolute bottom-0 w-full border-t border-blue-700/50 p-3">
          <button
            className={`flex items-center p-3 w-full text-blue-200 hover:bg-red-600/80 hover:text-white transition-all duration-200 rounded-lg
              ${collapsed ? 'justify-center' : 'justify-start'}`}
            onClick={onLogout}
          >
            <LogOut size={20} />
            {!collapsed && <span className="ml-3 font-medium">Cerrar Sesión</span>}
          </button>
        </div>
      </div>
    </div>
  );
};

const MobileTopBar = ({ setCollapsed }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="md:hidden bg-gradient-to-r from-blue-800 to-blue-900 text-white p-3 sticky top-0 z-10 shadow-lg flex justify-between items-center mobile-top-bar">
      <div className="flex items-center">
        <div className="bg-white p-1 rounded-md mr-3">
          <span className="text-blue-800 font-bold text-xs">EDU</span>
        </div>
        <div>
          <h1 className="font-bold text-lg">Portal de Tutores</h1>
          <div className="text-sm text-gray-500">EduSmart - {process.env.REACT_APP_VERSION}</div>
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <button 
          className="p-2 hover:bg-blue-700 rounded-lg transition-colors"
          onClick={() => setCollapsed(false)}
        >
          <MenuIcon size={20} />
        </button>
      </div>
    </div>
  );
};

const DesktopTopBar = ({ userName, fotoPerfil }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="hidden md:flex items-center justify-between bg-white p-4 border-b border-gray-200 shadow-sm">
      <div className="flex-1 max-w-xl">
        <div className="relative">
          <div>
            <h1 className="font-bold text-xl text-gray-800">Portal de Tutores</h1>
            <div className="text-sm text-gray-500">EduSmart - {process.env.REACT_APP_VERSION}</div>
          </div>
        </div>
      </div>
      
      <div className="flex items-center">
        <div className="relative">
          <button
            onClick={() => setShowMenu(!showMenu)}
            className="flex items-center focus:outline-none hover:bg-gray-50 p-2 rounded-lg transition-colors"
          >
            {fotoPerfil && fotoPerfil !== "Foto perfil" ? (
              <img
                src={fotoPerfil}
                alt="Foto de perfil"
                className="w-8 h-8 rounded-full object-cover mr-2 border-2 border-blue-500"
              />
            ) : (
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2 shadow-md">
                <span className="font-bold text-sm">{userName?.charAt(0) || 'U'}</span>
              </div>
            )}
            <span className="text-gray-700 font-medium">{userName}</span>
          </button>

          {showMenu && (
            <div className="absolute right-0 mt-2 w-48 bg-white border rounded-lg shadow-lg z-50 border-gray-200">
              <button
                className="block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 rounded-t-lg transition-colors"
                onClick={() => {
                  setShowMenu(false);
                  navigate('/dashboard/perfil');
                }}
              >
                <span className="font-medium">Mi Perfil</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Componente principal HomeScreenAdmin
const HomeScreenAdmin = () => {
  // CAMBIO 1: Sidebar siempre inicia colapsado
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [activeRoute, setActiveRoute] = useState('/dashboard');
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const { usuario, loadingUsuario, errorUsuario } = useUsers();
  const { configuracion, loadingConfiguracion, errorConfiguracion} = useConfiguracion();

  //filtrado de rutas
  const filteredRoutes = useMemo(() => {
    //console.log("🚀 Inicia el cálculo de rutas filtradas...");

    // 1. Verifica si existen los datos necesarios
    if (!usuario || !usuario.permisosUsuario) {
      console.warn("🚫 Usuario o permisos no encontrados. Se retorna un arreglo vacío.");
      return [];
    }

    // 2. Muestra los permisos del usuario actual
    const userPermissions = usuario.permisosUsuario;
    //console.log("✅ Permisos del usuario actual:", userPermissions);

    const finalRoutes = routes.map(route => {
      //console.log(`\nProcessing route: ${route.name}`);

      // 3. Filtra los submenús y muestra el proceso
      const visibleSubmenus = route.submenu?.filter(subItem => {
          const requiredPermission = subItem.permission;
          const hasPermission = userPermissions[requiredPermission] === true;
          
          /*
          console.log(
            `-- Submenu: '${subItem.name}' | Permiso: '${requiredPermission}' | Tiene?: ${hasPermission}`
          );
          */
          
          // La condición para mostrarlo es que no requiera permiso o que el usuario lo tenga
          return !requiredPermission || hasPermission;
        }) || [];

      //console.log(`-> Submenús visibles para '${route.name}':`, visibleSubmenus.map(s => s.name));

      // 4. Determina si la ruta principal es visible
      const hasVisibleSubmenus = visibleSubmenus.length > 0;
      const mainPermissionRequired = route.permission;
      const hasMainPermission = !mainPermissionRequired || userPermissions[mainPermissionRequired] === true;

      //console.log(`-> Ruta principal '${route.name}' | Permiso: '${mainPermissionRequired}' | Tiene?: ${hasMainPermission}`);
      //console.log(`-> ¿Se mostrará '${route.name}'?`, hasMainPermission || hasVisibleSubmenus ? "Sí" : "No");
      
      // 5. Devuelve la ruta si cumple las condiciones
      if (hasMainPermission || hasVisibleSubmenus) {
        return { ...route, submenu: visibleSubmenus };
      }
      
      return null;
    }).filter(Boolean); // Filtra los nulos

    // 6. Muestra el resultado final
    console.log("\n✅✅✅ Rutas finales filtradas:", finalRoutes);
    
    return finalRoutes;

  }, [usuario]);

  //filtrar la priemra ruta disponible
  // En HomeScreenAdmin.jsx, después del useMemo de filteredRoutes

  useEffect(() => {
    // No hagas nada si las rutas aún no se han calculado o no hay ninguna disponible
    if (filteredRoutes.length === 0) {
      return; 
    }

    // 1. Define la ruta de destino: la primera en la lista filtrada
    const firstAvailablePath = filteredRoutes[0].path;

    // 2. Obtén la ruta del primer submenú, si existe
    const firstSubmenuPath = filteredRoutes[0].submenu?.[0]?.path;

    // 3. Elige la ruta del submenú si existe, si no, la del menú principal
    const destinationPath = firstSubmenuPath || firstAvailablePath;

    // 4. Comprueba si el usuario está en la ruta raíz del dashboard ('/dashboard')
    // y si esa ruta de destino es diferente.
    if (location.pathname === '/dashboard' && location.pathname !== destinationPath) {
      console.log(`Redirigiendo de /dashboard a ${destinationPath}`);
      // Redirige al usuario a la primera ruta que tiene disponible
      navigate(destinationPath, { replace: true });
    }

  }, [filteredRoutes, location.pathname, navigate]); // Dependencias del efecto

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setActiveRoute(location.pathname + location.search);
  }, [location]);

  const handleNavigate = (path) => {
    setActiveRoute(path);
    navigate(path);
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const handleContentClick = () => {
    // Solo colapsar si no estamos en mobile (para evitar comportamiento indeseado)
    if (window.innerWidth >= 768 && !sidebarCollapsed) {
      setSidebarCollapsed(true);
    }
  };

  //cargar usuario
  if (loadingUsuario) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos del usuario...</p>
        </div>
      </div>
    );
  }

  if (usuario === null) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error al cargar datos de usuario</p>
        </div>
      </div>
    );
  }

  if (usuario.rol === "TUTOR" || usuario.rol === "PROSPECTO") {
    return <PermisoInsuficiente />;
  }

  //cargar configuracion
  if(loadingConfiguracion){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos de configuracion...</p>
        </div>
      </div>
    );
  }

  if(!configuracion){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error al cargar datos de configuracion</p>
        </div>
      </div>
    );
  }

  console.log("configuracion completa",configuracion.configuracion_completa);

  //Configuracion vital de la empresa
  if (!configuracion.configuracion_completa) {
    return <CompletarConfiguracion 
    configuracion={configuracion}
    />;
  } 
  
  return (
    <div className="flex flex-col h-screen bg-gray-50" style={{ 
      height: 'calc(var(--vh, 1vh) * 100)' 
    }}>
      <MobileTopBar setCollapsed={setSidebarCollapsed} />
  
      <div className="flex flex-1 overflow-hidden" style={{
        paddingTop: 'env(safe-area-inset-top)'
      }}>
        <Sidebar
          routes={filteredRoutes}
          activeRoute={activeRoute}
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
          onNavigate={handleNavigate}
          onLogout={handleLogout}
        />
        
        {/* CAMBIO 3: Agregar onClick al contenedor principal */}
        <div 
          className={`flex-1 overflow-auto flex flex-col transition-all duration-300 main-container ${sidebarCollapsed ? 'ml-0 md:ml-16' : 'ml-0 md:ml-64'}`}
          onClick={handleContentClick}
        >
          <DesktopTopBar userName={usuario.nombrecompleto} fotoPerfil={usuario.fotoPerfil} />
          
          <div className="flex-1 p-4 md:p-6 bg-gray-50">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );

};

export default HomeScreenAdmin;